import React, { useEffect, useRef, useState } from "react";
import CardCarousel from "../../../components/CardCarousel/CardCarousel";
import HeadPage from "../../../components/HeadPage/HeadPage";
import TopicsPreview from "../../../components/TopicsPreview/TopicsPreview";
import { fetchData } from "../../../fetcher";
import TheMallOutletLayout from "../../../layouts/TheMallOutletLayout/TheMallOutletLayout";
import styles from "../../../styles/pages/experiences.module.scss";
import ScrollDown from "../../../components/ScrollDown/ScrollDown";
import Related from "../../../components/Related/Related";

const ExperiencesPage = ({ menuItems, dataContent }) => {
  const scrollToRef = useRef(null);

  const getId = (str) => {
    return str.split(" ").slice(0, 1).pop().toLowerCase();
  };

  const [parent, setParent] = useState();
  const useIsomorphicLayoutEffect =
    typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;
  useIsomorphicLayoutEffect(() => {
    setParent(scrollToRef.current);
  }, [scrollToRef.current]);

  useEffect(() => {
    if (window.location && window.location.search) {
      const pathName = window.location.pathname;
      const id = window.location.search.replace("?q=", "");

      const elemToScroll = document.getElementById(id);
      // Rimozione query param
      window.history.pushState({}, document.title, "" + pathName);

      setTimeout(() => {
        // scroll to
        window.scrollTo({
          top: elemToScroll.offsetTop - 150,
          behavior: "smooth",
        });
      }, 150);

      // scroll to
      // window.scrollTo({
      //   top: elemToScroll.offsetTop - 50,
      //   behavior: "smooth",
      // });
    }
  }, []);

  return (
    <TheMallOutletLayout menuItems={menuItems}>
      <div id="head">
        <HeadPage {...dataContent?.head} scrollToRef={scrollToRef} />
      </div>
      <div ref={scrollToRef}>
        <TopicsPreview
          experiences
          section={getId(dataContent?.carousel[0].title)}
          topics={dataContent.topicsPreview}
          idList={dataContent.carousel.map((d) => getId(d.title))}
          parent={parent}
        />
        {dataContent.carousel.map((d, i) => (
          <div
            id={getId(d.title)}
            className={"anchor_section " + styles.cardCarousel}
            key={i}
          >
            <CardCarousel
              listOfBrands={d.items}
              loop={d.items.length > 4 ? true : false}
              centeredSlides={d.items.length > 4 ? true : false}
              darkTitle={d.title}
              hoverText={d.hoverText}
              autoplay={false}
            />
          </div>
        ))}

        <div className={"centeredSection" } style={{marginTop: '5rem', marginBottom: '5rem'}}>
          <Related related={dataContent.related} margin="0" />
        </div>
      </div>
    </TheMallOutletLayout>
  );
};

ExperiencesPage.getInitialProps = async (context) => {
  let menuItems = null;
  let dataContent = null;
  const { slug } = context.query;

  const resmenu = await fetchData("/init", context.query.locale);
  const data = await fetchData(slug, context.query.locale);

  if (resmenu) {
    menuItems = resmenu.menu;
  }

  if (data) {
    dataContent = data;
  }

  return {
    menuItems: menuItems,
    dataContent: dataContent,
  };
};

export default ExperiencesPage;
